module.exports = __webpack_public_path__ + "static/assets/81e91b5f4ee076f906ecd9eec19f0483.png";